var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { Text } from '../Text';
import styled from 'styled-components';
export var FileUploaderContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: fit-content;\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: fit-content;\n"])));
export var Title = styled(Text).attrs({
    forwardedAs: 'h2',
    weight: 'base',
    size: 3
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  text-align: left;\n  align-self: flex-start;\n"], ["\n  text-align: left;\n  align-self: flex-start;\n"])));
var templateObject_1, templateObject_2;
